import logo from "../assets/logo/orion-logo.png";

export const Logo = ({ className }: { className: string }) => {
 return (
  <a rel="Ansayfaya dön" href="/">
   <img
    src={logo}
    alt="Orion Twin"
    className={className + "object-contain object-center h-6 w-[120px] "}
   />
  </a>
 );
};
